import React, { useState } from 'react'
import { Col, List, Modal, Row, Select } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { ApplicationState } from 'src/store'
import { Button, Input, Text } from 'src/components/Ant'
import { ResumeVehicle, FullRequestVehicle, Id, PolicyRule } from 'src/types'
import CurrencyMask from 'src/components/Formik/InputCurrency/mask'
import Images from 'src/config/images'

import { WrapListItem } from './styles'

type Props = {
  isselected: boolean
  item: ResumeVehicle
  onSelect?(item: FullRequestVehicle): void
  policyRule: PolicyRule
}

function ListItem({
  isselected,
  item,
  onSelect,
  policyRule
}: //
Props) {
  const { vehicles } = useSelector((state: ApplicationState) => ({
    vehicles: state.vehicles
  }))
  const { t } = useTranslation()

  const [customerSupplierIdSelected, setCustomerSupplierIdSelected] =
    useState<Id>(item.values[0].customer_supplier_id)

  const [
    requestQuoteVehicleUniqueSelected,
    setRequestQuoteVehicleUniqueSelected
  ] = useState<Id>(item.values[0].request_quote_vehicle_unique)

  const masked = (value: number) =>
    `${CurrencyMask({ formatStr: true, value }).maskedValue} `

  return (
    <WrapListItem
      data-test-id={`vehicle-result-item-${item.request_quote_vehicle_unique}`}
      isselected={isselected ? 1 : 0}
      // key={item.request_quote_vehicle_hash}
      // style={style}
    >
      <List.Item.Meta
        avatar={
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              width: 200
            }}
          >
            <img
              alt="logo"
              src={
                item.vehicle_image_url ? item.vehicle_image_url : Images.noImage
              }
              style={{ maxHeight: 200, maxWidth: 200 }}
            />
            {!!item.company_image_url && (
              <img
                alt="logo"
                src={item.company_image_url}
                style={{
                  left: 0,
                  maxHeight: 70,
                  maxWidth: 70,
                  position: 'absolute',
                  top: 0
                }}
              />
            )}
          </div>
        }
        title={item.model}
        description={
          <Row gutter={24}>
            <Col span={15}>
              <span>
                <strong>
                  {t('web.services.vehicle.form.withdrawal.local')}:
                </strong>
                <span> {item.withdrawal_location}</span>
              </span>
              <br />
              <span>
                <strong>
                  {t('web.services.vehicle.form.devolution.local')}:
                </strong>
                <span> {item.return_location}</span>
              </span>
              <br />
              <span>-{item.gearbox}</span>
              <br />
              <span>-{item.information}</span>
              <br />
              {item.air_conditioning && (
                <span>- {t('web.services.vehicle.form.air-conditioning')}</span>
              )}
              <br />
            </Col>
            <Col
              offset={1}
              span={8}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              {onSelect ? (
                <Select
                  data-test-id="vehicle-result-item-value-list"
                  defaultValue={item.values[0].request_quote_vehicle_unique}
                  onChange={(value: Id) => {
                    setCustomerSupplierIdSelected(
                      item.values.find(
                        itemFind =>
                          itemFind.request_quote_vehicle_unique === value
                      ).customer_supplier_id
                    )
                    setRequestQuoteVehicleUniqueSelected(value)
                  }}
                >
                  {item.values.map((valueItem, index) => {
                    const currency = `BRL ${
                      CurrencyMask({
                        formatStr: true,
                        value: valueItem.total_value
                      }).maskedValue
                    }`
                    return (
                      <Select.Option
                        data-test-id={`vehicle-result-item-value-${index}`}
                        key={valueItem.request_quote_vehicle_unique}
                        title={currency}
                        value={valueItem.request_quote_vehicle_unique}
                      >
                        {currency}
                      </Select.Option>
                    )
                  })}
                </Select>
              ) : (
                item.values.map((itemMap, index: number) => {
                  return itemMap.request_quote_vehicle_unique ===
                    requestQuoteVehicleUniqueSelected ? (
                    <span key={index}>
                      <Text>{masked(itemMap.total_value)}</Text>
                      <Text strong title="web.services.vehicle.selected" />
                    </span>
                  ) : (
                    <Text key={index}>{masked(itemMap.total_value)}</Text>
                  )
                })
              )}
              {onSelect && (
                <Button
                  block
                  data-test-id={`vehicle-result-item-select-${item.request_quote_vehicle_unique}`}
                  onClick={() => {
                    const fullRequestVehicle: FullRequestVehicle = {
                      customer_supplier_id: customerSupplierIdSelected,
                      message_id: [...vehicles.message_id],
                      request_quote_hash: item.request_quote_hash,
                      request_quote_vehicle_hash: [
                        item.request_quote_vehicle_hash
                      ],
                      request_quote_vehicle_route_hash:
                        item.request_quote_route_hash,
                      request_quote_vehicle_unique: [
                        `${requestQuoteVehicleUniqueSelected}`
                      ],
                      travelers: [],
                      situation: null
                    }

                    if (
                      policyRule?.policy_request_vehicle_rule?.active &&
                      policyRule?.policy_request_vehicle_rule?.lowest_fare
                    ) {
                      let lowerValue = vehicles.list[0].values[0].total_value
                      let selectedValue = 0

                      vehicles.list.forEach(vehicleItem => {
                        vehicleItem.values.forEach(valueItem => {
                          if (valueItem.total_value < lowerValue) {
                            lowerValue = valueItem.total_value
                          }

                          if (
                            fullRequestVehicle
                              .request_quote_vehicle_unique[0] ===
                            valueItem.request_quote_vehicle_unique
                          ) {
                            selectedValue = valueItem.total_value
                          }
                        })
                      })

                      if (selectedValue > lowerValue) {
                        switch (
                          policyRule?.policy_request_vehicle_rule.action
                        ) {
                          case 'ALERT':
                            Modal.confirm({
                              cancelText: (
                                <Text onlyText title="common.actions.cancel" />
                              ),
                              content: (
                                <>
                                  <Text title="web.services.vehicle.validation.policy.min-fare.alert.content" />
                                  <Input
                                    allowClear
                                    name="minFareHotelJustification"
                                    placeholder="web.services.vehicle.validation.policy.min-fare.alert.justification.placeholder"
                                    size="large"
                                  />
                                </>
                              ),
                              okText: (
                                <Text onlyText title="common.actions.yes" />
                              ),
                              title: (
                                <Text
                                  onlyText
                                  title="web.services.vehicle.validation.policy.min-fare.alert.title"
                                />
                              ),
                              onCancel() {},
                              onOk: () => {
                                const justification: any =
                                  document.querySelector(
                                    "input[name='minFareHotelJustification']"
                                  )
                                if (justification?.value.trim().length) {
                                  onSelect({
                                    ...fullRequestVehicle,
                                    justification: [justification.value]
                                  })
                                }
                              }
                            })
                            return
                          case 'BLOCK':
                            Modal.error({
                              content: (
                                <Text
                                  onlyText
                                  title="web.services.vehicle.validation.policy.min-fare.block.content"
                                />
                              ),
                              onOk() {},
                              okText: (
                                <Text onlyText title="common.actions.close" />
                              ),
                              title: (
                                <Text
                                  onlyText
                                  title="web.services.vehicle.validation.policy.min-fare.block.title"
                                />
                              )
                            })
                            return
                        }
                      }
                    }
                    onSelect({
                      ...fullRequestVehicle
                    })
                  }}
                  style={{ marginTop: 8 }}
                  title="common.actions.select"
                  type="primary"
                />
              )}
            </Col>
          </Row>
        }
      />
    </WrapListItem>
  )
}

export default ListItem
